import React, { useEffect, useState } from 'react';
import { HeadphonesIcon, MusicIcon, FilmIcon, BriefcaseIcon } from 'lucide-react';
export const MoreThanLessonsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('more-than-lessons');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const topics = [{
    icon: <HeadphonesIcon className="h-6 w-6 text-blue-600" data-id="element-2722" />,
    title: 'Music Production',
    description: 'Explore music production topics like beat creation, recording, mixing, and modern production tools.'
  }, {
    icon: <MusicIcon className="h-6 w-6 text-blue-600" data-id="element-2723" />,
    title: 'Music Theory & Harmony',
    description: 'Cover essential music theory topics including harmony, chord progressions, and harmonic analysis.'
  }, {
    icon: <FilmIcon className="h-6 w-6 text-blue-600" data-id="element-2724" />,
    title: 'Film, TV, and Game Scoring',
    description: 'Explore topics related to writing and producing music for film, TV, and games, including orchestration and sync.'
  }, {
    icon: <BriefcaseIcon className="h-6 w-6 text-blue-600" data-id="element-2725" />,
    title: 'Music Business',
    description: 'Explore key music business topics like royalties, distribution, publishing, and contracts.'
  }];
  return <section id="more-than-lessons" className="py-24 bg-white" data-id="element-2726">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2727">
        <div className="text-center mb-16" data-id="element-2728">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-2729">
            More Than Just Instrument Lessons
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2730">
            Expand your music knowledge with expert-led lessons in modern music
            topics.
          </p>
        </div>
        {/* Topics in a single row */}
        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-2731">
          {topics.map((topic, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-lavender/20 h-full" data-id="element-2732">
              <div className="flex-shrink-0 mb-4 bg-lavender/10 rounded-full w-12 h-12 flex items-center justify-center" data-id="element-2733">
                {topic.icon}
              </div>
              <h4 className="text-lg font-medium text-navy-900 mb-2" data-id="element-2734">
                {topic.title}
              </h4>
              <p className="text-gray-600" data-id="element-2735">{topic.description}</p>
            </div>)}
        </div>
        {/* Full-width studio image */}
        <div className={`transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-2736">
          <div className="relative w-full" data-id="element-2737">
            <div className="absolute -inset-1 bg-gradient-to-r from-lavender via-deep-pink to-golden opacity-20 blur-xl rounded-2xl" data-id="element-2738"></div>
            <div className="relative rounded-xl overflow-hidden w-full aspect-[21/9]" data-id="element-2739">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fjM3JbPu5ccji35vVYPfZ1/production.jpg" alt="Two music producers working at a professional mixing console in a modern recording studio" className="w-full h-full object-cover rounded-xl" data-id="element-2740" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};